import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8e647ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "q-pa-md"
}
const _hoisted_2 = { class: "q-px-sm justified-center" }
const _hoisted_3 = {
  key: 2,
  class: "q-pt-md q-mx-md"
}
const _hoisted_4 = { class: "q-px-sm justified-center" }
const _hoisted_5 = {
  key: 3,
  class: "q-pt-md q-px-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_company_item = _resolveComponent("company-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_paginated_counter = _resolveComponent("paginated-counter")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_empty_placeholder = _resolveComponent("empty-placeholder")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", {
    onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goNextStep && _ctx.goNextStep(...args)), ["enter"])),
    id: "select-company"
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_q_spinner, {
          key: 0,
          class: "q-mx-lg",
          color: "primary",
          size: "40px"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_toolbar, _normalizeProps(_guardReactiveProps(_ctx.TEXT_QUATERNARY_TITLE)), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t(`LEAD_CREATION_STEPS.STEP-${_ctx.step}`, { a: _ctx.t('COMPANY.LOW.ART'), company: _ctx.t('COMPANY.LOW.SING') })), 1)
      ]),
      _: 1
    }, 16),
    (_ctx.preselectedCompany)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_item_label, _mergeProps({ class: "q-px-sm q-mb-sm ellipsis" }, _ctx.TEXT_CARD_BODY), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('CURRENT_COMPANY', { company: _ctx.t('COMPANY.LOW.SING') })), 1)
            ]),
            _: 1
          }, 16),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_company_item, {
              company: _ctx.preselectedCompany,
              "selected-brief": _ctx.selectedBrief,
              "selected-category": _ctx.selectedCategory,
              "selected-company": _ctx.selectedCompany,
              onSelectedCompany: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCompany(_ctx.preselectedCompany))),
              "on@nextStepFromItem": _ctx.goNextStep
            }, null, 8, ["company", "selected-brief", "selected-category", "selected-company", "on@nextStepFromItem"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_toolbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_input, _mergeProps({
          label: _ctx.t('COMPANY_NAME'),
          placeholder: _ctx.t('SEARCH_COMPANY_PLACEHOLDER', { company: _ctx.t('COMPANY.LOW.SING') }),
          autofocus: "",
          class: "full-width",
          maxlength: _ctx.MAX_LENGTH.COMPANY.NAME
        }, _ctx.INPUT_LG, {
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchText) = $event)),
            _ctx.getSuggestedCompanies
          ],
          onKeyup: _withKeys(_withModifiers(_ctx.goNextStep, ["stop"]), ["enter"])
        }), {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: _ctx.ICONS_NAME.SEARCH_OUTLINE
            }, null, 8, ["name"])
          ]),
          _: 1
        }, 16, ["label", "placeholder", "maxlength", "modelValue", "onKeyup", "onUpdate:modelValue"])
      ]),
      _: 1
    }),
    (_ctx.newCompany)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_q_item_label, _mergeProps({ class: "q-px-sm q-mb-sm ellipsis" }, _ctx.TEXT_CARD_BODY), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('NO_MATCH', { text: _ctx.searchText })), 1)
            ]),
            _: 1
          }, 16),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_company_item, {
              company: _ctx.newCompany,
              "selected-brief": _ctx.selectedBrief,
              "selected-category": _ctx.selectedCategory,
              "selected-company": _ctx.selectedCompany,
              onSelectedCompany: _ctx.selectNewCompany,
              "on@nextStepFromItem": _ctx.goNextStep
            }, null, 8, ["company", "selected-brief", "selected-category", "selected-company", "onSelectedCompany", "on@nextStepFromItem"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSearching && _ctx.hasResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_q_item_label, _mergeProps({ class: "q-mb-sm" }, _ctx.TEXT_CARD_BODY), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('COMPANIES_FOUND')), 1)
            ]),
            _: 1
          }, 16),
          _createVNode(_component_q_card, { class: "bordered" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tabs, _mergeProps(_ctx.TABS_PROPS, {
                class: "tab-xl",
                modelValue: _ctx.currentTab,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentTab) = $event))
              }), {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultTabs, ([key, tab]) => {
                    return (_openBlock(), _createBlock(_component_q_tab, {
                      key: key,
                      name: key
                    }, {
                      default: _withCtx(() => [
                        (key === _ctx.nexusSourceValues.CORTELLIS)
                          ? (_openBlock(), _createBlock(_component_q_icon, _mergeProps({
                              key: 0,
                              name: _ctx.ICONS_NAME.CORTELLIS
                            }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(tab.name), 1),
                        _createVNode(_component_paginated_counter, {
                          "rows-count": tab.searchResults.length,
                          loading: _ctx.loading
                        }, null, 8, ["rows-count", "loading"])
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 16, ["modelValue"]),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_tab_panels, {
                "keep-alive": "",
                class: "bg-white",
                animated: "",
                "transition-next": "fade",
                "transition-prev": "fade",
                modelValue: _ctx.currentTab,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentTab) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultTabs, ([key, tab]) => {
                    return (_openBlock(), _createBlock(_component_q_tab_panel, {
                      key: key,
                      name: key
                    }, {
                      default: _withCtx(() => [
                        (tab.searchResults.length > 0)
                          ? (_openBlock(), _createBlock(_component_q_list, {
                              key: 0,
                              class: "scroll card-list"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.searchResults, (company, index) => {
                                  return (_openBlock(), _createBlock(_component_company_item, {
                                    company: company,
                                    key: index,
                                    "selected-category": _ctx.selectedCategory,
                                    "selected-brief": _ctx.selectedBrief,
                                    "selected-company": _ctx.selectedCompany,
                                    onSelectedCompany: _ctx.selectCompany,
                                    "on@nextStepFromItem": _ctx.goNextStep
                                  }, null, 8, ["company", "selected-category", "selected-brief", "selected-company", "onSelectedCompany", "on@nextStepFromItem"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_empty_placeholder, {
                              key: 1,
                              icon: _ctx.ICONS_NAME.DOCUMENT_ADD,
                              "custom-props": { icon: '80px' },
                              hint: _ctx.t('TABS.EMPTY_HINT', { object: _ctx.t('COMPANY.LOW.SING') }),
                              message: _ctx.t('TABS.EMPTY_MESSAGE')
                            }, null, 8, ["icon", "hint", "message"]))
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 32))
}